<div class="d-flex justify-content-center align-items-center mt-3 person">
  <mat-icon class="large" [class.active]="producer$ | async">person</mat-icon>
</div>
<div class="d-flex flex-column justify-content-center align-items-center">
  <h5 class="mb-0">{{ profile?.username }}</h5>
  <caption class="pt-0">
    {{
      profile?.email
    }}
  </caption>
  <button mat-raised-button color="primary" class="mt-2" (click)="redirectToSSoProfile()">
    <mat-icon>info</mat-icon>
    <span>{{ 'userProfile.editProfile' | translate }}</span>
  </button>
</div>
